<template>
  <v-container fluid>
    <div v-if="loading">
      <v-skeleton-loader type="list-item-avatar, list-item-three-line, actions" class="mb-3"></v-skeleton-loader>
      <v-skeleton-loader type="table"></v-skeleton-loader>
    </div>
    <div v-else>
      <v-row class="mt-0 mb-2" justify="space-between" no-gutters>
        <v-col cols="12" md="4">
          <v-card class="py-3 px-4 vcard_area">
            <v-row>
              <v-col cols="12" md="7">
                <div class="text-h1 mb-2">Usuários</div>
                <div class="text text--thin mb-2">Realizar novo cadastro de usuário</div>
                <v-btn @click="dialogNovo = true" color="primary" class="mt-1"><v-icon class="mr-1">person</v-icon>Novo usuário</v-btn>
              </v-col>
              <v-col cols="12" md="5">
                <div class="icon_area" :class="$vuetify.theme.dark ? 'dark_area' : 'white_area'">
                  <v-icon>add</v-icon>
                </div>
              </v-col>
            </v-row>
          </v-card>
        </v-col>
      </v-row>
      <v-data-table
        :headers="headers"
        :items="dados"
        disable-sort
        :server-items-length="total"
        :options.sync="options"
        :search="search"
        loading-text="Carregando... Por favor aguarde"
        :loading="carregando"
        class="elevation-1 base_table mt-4"
        :footer-props="{
          itemsPerPageOptions: [5,10,15,20,25,50,100],
          showFirstLastPage: true,
          firstIcon: 'skip_previous',
          lastIcon: 'skip_next',
          prevIcon: 'chevron_left',
          nextIcon: 'chevron_right'
        }"
        :header-props="{
          sortIcon: 'north',
        }"
      >
        <template v-slot:top>
          <v-row no-gutters align="center" justify="space-between">
            <v-row no-gutters>
              <div class="py-2 px-2">
                <v-form @submit.prevent="applyFilter()">
                  <v-text-field
                    clearable
                    hide-details=""
                    clear-icon="close"
                    v-model="search"
                    outlined
                    label="Busca"
                    @click:clear="limparBusca()"
                  ></v-text-field>
                </v-form>
              </div>
              <div class="py-2 px-2" v-if="$root.Permissions.admin()">
                <v-autocomplete
                  :menu-props="{ offsetY: true}"
                  v-model="distribuidor"
                  :items="distribuidores"
                  hide-details=""
                  clearable
                  clear-icon="close"
                  label="Distribuidor"
                  append-icon="expand_more"
                  outlined
                  @change="applyFilter()"
                  @click:clear="applyFilter()"
                >
                </v-autocomplete>
              </div>
              <div class="py-2 px-2" v-if="$root.Permissions.admin() || $root.Permissions.distributor()">
                <v-autocomplete
                  :menu-props="{ offsetY: true}"
                  v-model="revendedor"
                  :items="revendedores"
                  hide-details=""
                  clearable
                  clear-icon="close"
                  label="Revendedor"
                  append-icon="expand_more"
                  outlined
                  @change="applyFilter()"
                  @click:clear="applyFilter()"
                >
                </v-autocomplete>
              </div>
              <div class="py-2 px-2" v-if="!$root.Permissions.integrator()">
                <v-autocomplete
                  :menu-props="{ offsetY: true}"
                  v-model="integrador"
                  :items="integradores"
                  hide-details=""
                  clearable
                  clear-icon="close"
                  label="Integrador"
                  append-icon="expand_more"
                  outlined
                  @change="applyFilter()"
                  @click:clear="applyFilter()"
                >
                </v-autocomplete>
              </div>
            </v-row>
            <div>
              <v-menu
                bottom
                center
                offset-y
                max-height="400"
              >
                <template v-slot:activator="{ on, attrs }">
                  <div v-bind="attrs" v-on="on">
                    Exportar
                    <v-icon>arrow_drop_down</v-icon>
                  </div>
                </template>
                <v-list>
                  <v-list-item @click="exportXls()">
                    <v-list-item-icon class="mr-1">
                      <v-icon color="primary">receipt_long</v-icon>
                    </v-list-item-icon>
                    <v-list-item-title>Exportar para XLS</v-list-item-title>
                  </v-list-item>
                  <v-list-item @click="exportPdf()">
                    <v-list-item-icon class="mr-1">
                      <v-icon color="primary">picture_as_pdf</v-icon>
                    </v-list-item-icon>
                    <v-list-item-title>Exportar / Imprimir PDF</v-list-item-title>
                  </v-list-item>
                  <!-- <v-list-item @click="dialogImportacao = true">
                    <v-list-item-icon class="mr-1">
                      <v-icon color="primary">ios_share</v-icon>
                    </v-list-item-icon>
                    <v-list-item-title>Importar contatos</v-list-item-title>
                  </v-list-item> -->
                </v-list>
              </v-menu>
            </div>
          </v-row>
        </template>
        <template v-if="$root.Permissions.admin" v-slot:item.int_dis_nome="{ item }">
          <div>{{item.int_dis_nome}}</div>
        </template>
        <template v-slot:item.actions="{ item }">
          <v-row no-gutters align="center" justify="center">
            <v-tooltip top>
              <template v-slot:activator="{ on, attrs }">
                <v-icon v-bind="attrs" v-on="on" @click="openNovo(item)" color="primary" class="mr-2">
                  edit
                </v-icon>
              </template>
              <span>Editar</span>
            </v-tooltip>
            <v-tooltip top>
              <template v-slot:activator="{ on, attrs }">
                <v-icon v-bind="attrs" v-on="on" @click="openDialogDelete(item)" color="primary" class="ml-2">
                  delete
                </v-icon>
              </template>
              <span>Excluir</span>
            </v-tooltip>
          </v-row>
        </template>
      </v-data-table>
    </div>
    <v-dialog
      v-model="dialogNovo"
      persistent
      max-width="500px"
    >
      <v-card class="ui-dialog-top">
        <v-row align="center" justify="space-between">
          <v-col cols="10">
            {{usuario.uuid_usu_id ? 'Editar usuário' : 'Novo usuário'}}
          </v-col>
          <v-col cols="2" class="text-right">
            <v-icon @click="closeDialog()">close</v-icon>
          </v-col>
        </v-row>
      </v-card>
      <v-card class="ui-dialog-content">
        <v-form ref="formUsuarios">
          <v-row>
            <v-col cols="12" sm="12" md="12" lg="12" xl="12" v-if="!$root.Permissions.integrator()">
              <v-switch
                hide-details
                class="ml-4 mt-0 mb-2"
                color="success"
                v-model="usuario.usu_permissao_publicidades"
                :loading="salvando"
                :disabled="salvando"
                label="Permite baixar pacotes de publicidades"
                :readonly="$root.Permissions.integrator()"
              ></v-switch>
            </v-col>
            <v-col cols="12" sm="6" md="6" lg="6" xl="6" class="pb-0 pt-0">
              <v-text-field
                v-model="usuario.usu_nome"
                label="Nome*"
                :rules="[rules.required]"
                autofocus
                outlined
                :disabled="salvando"
                :loading="salvando"
              ></v-text-field>
            </v-col>
            <v-col cols="12" sm="6" md="6" lg="6" xl="6" class="pt-0 pb-0">
              <v-text-field
                v-model="usuario.usu_email"
                label="E-mail*"
                outlined
                :rules="[rules.required, rules.email]"
                :disabled="salvando"
                :loading="salvando"
              ></v-text-field>
            </v-col>
            <v-col cols="12" sm="6" md="6" lg="6" xl="6" class="pb-0 pt-0">
              <v-autocomplete
                :menu-props="{ offsetY: true}"
                v-model="usuario.uuid_gru_id"
                :items="grupos"
                clearable
                clear-icon="close"
                label="Grupo*"
                :rules="[rules.required]"
                append-icon="expand_more"
                :loading="salvando"
                outlined
              >
              </v-autocomplete>
            </v-col>
            <v-col cols="12" sm="6" md="6" lg="6" xl="6" class="pt-0 pb-0">
                <v-text-field
                  outlined
                  label="Telefone"
                  v-model="usuario.usu_telefone"
                  v-mask="'(##) #####-####'"
                  :loading="salvando"
                  :disabled="salvando"
                ></v-text-field>
            </v-col>
            <v-col cols="12" sm="6" md="6" lg="6" xl="6" class="pt-0">
              <v-text-field
                v-model="usuario.usu_apelido"
                label="Usuário*"
                :rules="[rules.required]"
                outlined
                :disabled="salvando"
                :loading="salvando"
              ></v-text-field>
            </v-col>
            <v-col cols="12" sm="6" md="6" lg="6" xl="6" class="pt-0">
              <v-text-field
                @click:append="show1 = !show1"
                :label="usuario.uuid_usu_id ? 'Preencha caso desejar alterar a senha' : 'Senha*'"
                hint="Mínimo 6 caracteres"
                counter
                outlined
                :loading="salvando"
                :disabled="salvando"
                :type="show1 ? 'text' : 'password'"
                v-model="usuario.password"
                :append-icon="show1 ? 'remove_red_eye' : 'visibility_off'"
                :rules="usuario.uuid_usu_id ? [] : [rules.required, rules.min]"
              ></v-text-field>
            </v-col>
            <v-col cols="12" sm="12" md="12" lg="12" xl="12" class="pt-0">
              <v-file-input
                show-size
                clearable
                ref="file"
                v-model="usuario.usu_imagem"
                prepend-icon="image"
                label="Adicionar imagem"
                clear-icon="close"
                truncate-length="50"
                :loading="salvando"
                :disabled="salvando"
                v-if="isObject(usuario.usu_imagem)"
                outlined
                :rules="[rules.size]"
                hint="Tamanho recomendado: 150x150px"
                persistent-hint
              ></v-file-input>
            </v-col>
            <v-col cols="12" sm="12" md="12" lg="12" xl="12" class="pt-0 mb-6" v-if="usuario.usu_imagem && !isObject(usuario.usu_imagem)">
              <v-row no-gutters justify="start" align="center">
                <div v-if="usuario.usu_imagem">
                  <img alt="Imagem do usuário" :src="usuario.usu_imagem" class="logotipo">
                </div>
                <div>
                  <v-tooltip top>
                    <template v-slot:activator="{ on, attrs }">
                      <v-icon @click="dialogDeletarImagem = true" v-bind="attrs" v-on="on" color="primary">delete</v-icon>
                    </template>
                    <span>Remover imagem</span>
                  </v-tooltip>
                </div>
              </v-row>
            </v-col>
          </v-row>
         </v-form>
        <v-divider></v-divider>
        <v-row no-gutters class="mt-4 mb-0" align="center" justify="space-between">
          <v-btn
            color="cancel"
            :loading="salvando"
            :disabled="salvando"
            @click="closeDialog()"
          >
            Cancelar
          </v-btn>
          <v-btn
            color="primary"
            @click="saveEditUser()"
            :loading="salvando"
            :disabled="salvando"
          >
            Salvar
          </v-btn>
        </v-row>
      </v-card>
    </v-dialog>
    <v-dialog v-model="dialogDeletarImagem" max-width="400">
      <v-card class="ui-dialog-top">
        <v-row align="center" justify="space-between">
          <v-col cols="10">
            Remover Imagem
          </v-col>
          <v-col cols="2" class="text-right">
            <v-icon @click="dialogDeletarImagem = false">close</v-icon>
          </v-col>
        </v-row>
      </v-card>
      <v-card class="ui-dialog-content">
        <div class="mb-5">
          Tem certeza que deseja remover a imagem?
        </div>
        <v-divider class="mb-3"></v-divider>
        <v-row
          align="center"
          justify="space-between"
          class="px-5 py-5"
        >
          <v-btn
            color="cancel"
            :loading="salvando"
            :disabled="salvando"
            @click="dialogDeletarImagem = false"
          >
            Cancelar
          </v-btn>
          <v-btn
            color="success"
            :loading="salvando"
            :disabled="salvando"
            @click="removeImagem()"
          >
            Remover
          </v-btn>
        </v-row>
      </v-card>
    </v-dialog>
    <v-dialog v-model="dialogExcluir" max-width="400">
      <v-card class="ui-dialog-top">
        <v-row align="center" justify="space-between">
          <v-col cols="10">
            Excluir Usuário
          </v-col>
          <v-col cols="2" class="text-right">
            <v-icon @click="cancelUsuarioDelete()">close</v-icon>
          </v-col>
        </v-row>
      </v-card>
      <v-card class="ui-dialog-content">
        <div class="text-h3 mb-5">
          Tem certeza que deseja excluir Usuário <b class="text-primary">{{usuario ? usuario.usu_nome : ''}}</b>?
        </div>
        <v-divider class="mb-3"></v-divider>
        <v-row
          align="center"
          justify="space-between"
          class="px-5 py-5"
        >
          <v-btn
            color="cancel"
            :disabled="salvando"
            :loading="salvando"
            @click="cancelUsuarioDelete()"
          >
            Cancelar
          </v-btn>
          <v-btn
            color="success"
            :disabled="salvando"
            :loading="salvando"
            @click="removeUser()"
          >
            Excluir
          </v-btn>
        </v-row>
      </v-card>
    </v-dialog>
  </v-container>
</template>

<script>
import Api from '@API'
export default {
  data () {
    return {
      search: '',
      total: 0,
      options: {},
      user: null,
      loading: true,
      carregando: false,
      salvando: false,
      dialogNovo: false,
      dialogExcluir: false,
      dialogDeletarImagem: false,
      show1: false,
      revendedor: null,
      revendedores: [],
      revendedoresCadastro: [],
      headers: [
        {
          text: 'ID',
          align: 'start',
          value: 'usu_id'
        },
        { text: 'Nome', value: 'usu_nome' },
        { text: 'E-mail', value: 'usu_email' },
        { text: 'Usuário', value: 'usu_apelido' },
        { text: 'Integrador / Distribuidor', value: 'int_dis_nome' },
        {
          text: 'Ações',
          value: 'actions',
          align: 'center',
          sortable: false,
          width: 110
        }
      ],
      dados: [],
      rules: {
        required: value => !!value || 'Obrigatório.',
        min: v => v.length >= 6 || 'Mínimo 6 caracteres',
        size: value => !value || value.size < 10000000 || 'Imagem precisa ter menos que 10MB!',
        email: value => {
          const pattern = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
          return pattern.test(value) || 'E-mail inválido.'
        }
      },
      usuario: {
        usu_nome: '',
        usu_email: '',
        usu_apelido: '',
        usu_permissao_publicidades: '',
        usu_telefone: '',
        uuid_dis_id: null,
        uuid_int_id: null,
        uuid_rev_id: null,
        uuid_gru_id: null,
        password: ''
      },
      distribuidores: [],
      distribuidor: null,
      integradores: [],
      integrador: null,
      grupos: [],
      distribuidorAnterior: null,
      integradoresCadastro: [],
      loadingIntegradores: false,
      loadingRevendedores: false
    }
  },
  watch: {
    options: {
      handler () {
        this.getUsers()
      },
      deep: true
    }
  },
  methods: {
    exportPdf () {
      let url = 'usuarios?'
      if (this.search) url += `&busca=${this.search}`
      if (this.distribuidor && !this.revendedor && !this.integrador) url += '&distribuidor=' + this.distribuidor
      if (this.revendedor && !this.integrador) url += '&revendedor=' + this.revendedor
      if (this.integrador) url += '&integrador=' + this.integrador

      this.$root.Export.PDF(this, {
        titulo: 'Lista de usuários',
        tabela: {
          headers: this.headers,
          url
        }
      })
    },
    async exportXls () {
      this.loadingXls = true
      Api.post('relatorios/exportar', {
        headers: this.someHeader(),
        busca: this.search,
        distribuidor: this.distribuidor ? this.distribuidor : null,
        integrador: this.integrador ? this.integrador : null,
        type: 'usuarios'
      })
        .then(res => {
          this.downloadXls(res.data.url)
          this.removeXls(res.data.url)
          this.loadingXls = false
        })
        .catch(err => {
          console.log(err)
          this.$root.SnackControl.open(this, {
            text: 'Ops, ocorreu um erro ao fazer o donwload!',
            color: 'error'
          })
        })
    },
    async downloadXls (url) {
      const a = document.createElement('a')
      a.href = url
      a.download = url.split('/').pop()
      document.body.appendChild(a)
      a.click()
      document.body.removeChild(a)
    },
    removeXls (url) {
      let data = {
        url: url
      }
      Api.post('relatorios/remove-s3', data)
    },
    someHeader () {
      let cabecalhos = []
      this.headers.map(header => {
        if (header.text !== 'ID' && header.text !== 'Ações' && header.text !== 'Usuários' && header.text !== 'Imagem') cabecalhos.push(header)
      })
      return cabecalhos
    },
    loadFunctions () {
      let filters = this.$route.query
      if (filters.busca) this.search = filters.busca
      if (filters.distribuidor) this.distribuidor = filters.distribuidor
      if (filters.integrador) this.integrador = filters.integrador
      this.removeHeader()
      this.getDistributors()
      this.getRevendors(this.distribuidor)
      this.getIntegrators(this.distribuidor)
      this.getGroups()
    },
    isObject (val) {
      if (val) {
        return val instanceof Object
      } else {
        return true
      }
    },
    removeHeader () {
      if (!this.$root.Permissions.admin()) {
        delete this.headers[4]
      }
    },
    getDistributors () {
      Api.get('distribuidores')
        .then(res => {
          if (res.data && res.data.length > 0) {
            let info = []
            res.data.map(item => {
              info.push({
                value: item.uuid_dis_id,
                text: item.dis_nome_fantasia
              })
            })
            this.distribuidores = info
          }
        })
    },
    async getRevendors (distribuidor = null, cadastro = false) {
      this.loadingRevendedores = true
      let url = 'revendedores'

      if (distribuidor) {
        url = `distribuidores/${distribuidor}/revendedores`
      }
      await Api.get(url)
        .then(res => {
          var arrayInt = []
          res.data.map(rev => {
            arrayInt.push({
              'text': rev.rev_nome,
              'value': rev.uuid_rev_id
            })
          })
          if (cadastro || (!cadastro && !distribuidor)) {
            this.revendedoresCadastro = arrayInt
          }

          if (!cadastro) {
            this.revendedores = arrayInt
          }
          this.loadingRevendedores = false
        })
        .catch(err => {
          this.loadingRevendedores = false
          this.$root.SnackControl.open(this, {
            text: err.response.data.status ? err.response.data.status : 'Ops, ocorreu um erro ao buscar os revendedores!',
            color: 'error'
          })
          console.log(err)
        })
    },
    async getIntegrators (distribuidor = null, cadastro = false) {
      this.loadingIntegradores = true
      let url = 'integradores'

      if (distribuidor) {
        url = `distribuidores/${distribuidor}/integradores`
      }
      await Api.get(url)
        .then(res => {
          var arrayInt = []
          res.data.map(int => {
            arrayInt.push({
              'text': int.int_nome,
              'value': int.uuid_int_id
            })
          })
          if (cadastro || (!cadastro && !distribuidor)) {
            this.integradoresCadastro = arrayInt
          }

          if (!cadastro) {
            this.integradores = arrayInt
          }
          this.loadingIntegradores = false
        })
        .catch(err => {
          this.loadingIntegradores = false
          this.$root.SnackControl.open(this, {
            text: err.response.data.status ? err.response.data.status : 'Ops, ocorreu um erro ao buscar os integradores!',
            color: 'error'
          })
          console.log(err)
        })
    },
    async getGroups () {
      this.loading = true
      await Api.get('grupos')
        .then(res => {
          if (res.data && res.data.length > 0) {
            let info = []
            res.data.map(item => {
              info.push({
                value: item.uuid_gru_id,
                text: item.gru_nome
              })
            })
            this.grupos = info
            this.loading = false
          }
        })
        .catch(err => {
          this.loading = false
          this.$root.SnackControl.open(this, {
            text: err.response.data.status ? err.response.data.status : 'Ops, ocorreu um erro ao buscar os grupos!',
            color: 'error'
          })
          console.log(err)
        })
    },
    limparBusca () {
      this.search = null
      this.options.page = 1
      this.applyFilter()
    },
    applyFilter () {
      this.carregando = true

      let query = Object.assign({},
        this.search ? { busca: this.search } : '',
        this.distribuidor ? { distribuidor: this.distribuidor } : '',
        this.revendedor ? { revendedor: this.revendedor } : '',
        this.integrador ? { integrador: this.integrador } : ''
      )

      this.$router.replace({name: this.$route.name, query: query}).catch(() => {})

      this.options.page = 1
      this.getRevendors(this.distribuidor)
      this.getIntegrators(this.distribuidor)
      this.getUsers()
    },
    async getUsers () {
      this.carregando = true
      this.total = 0
      const { page, itemsPerPage } = this.options
      let pagina = 1
      let itensPagina = 1
      let endpoint = ''

      if (page) pagina = page
      if (itemsPerPage) itensPagina = itemsPerPage
      if (this.search) endpoint += `&busca=${this.search}`
      if (this.distribuidor && !this.revendedor && !this.integrador) endpoint += '&distribuidor=' + this.distribuidor
      if (this.revendedor && !this.integrador) endpoint += '&revendedor=' + this.revendedor
      if (this.integrador) endpoint += '&integrador=' + this.integrador

      await Api.get(`usuarios?page=${pagina}&per_page=${itensPagina}${endpoint}`)
        .then(res => {
          if (res.data) {
            let info = []
            if (res.data.data.length > 0) {
              res.data.data.map(item => {
                info.push({
                  usu_id: item.usu_id,
                  usu_nome: item.usu_nome,
                  usu_email: item.usu_email,
                  usu_apelido: item.usu_apelido,
                  usu_imagem: item.usu_imagem,
                  modulo: item.grupo ? item.grupo.gru_nome : 'Grupo removido',
                  uuid_gru_id: item.grupo ? item.grupo.uuid_gru_id : null,
                  uuid_usu_id: item.uuid_usu_id,
                  usu_permissao_publicidades: item.usu_permissao_publicidades,
                  uuid_int_id: item.integrador != null ? item.integrador.uuid_int_id : null,
                  uuid_dis_id: item.distribuidor != null ? item.distribuidor.uuid_dis_id : null,
                  uuid_rev_id: item.revendedor != null ? item.revendedor.uuid_rev_id : null,
                  int_dis_nome: this.retornaUser(item)
                })
              })
            }
            this.total = res.data.total
            this.dados = info
          }
          this.carregando = false
        })
        .catch(err => {
          console.log(err)
          this.carregando = false
          this.$root.SnackControl.open(this, {
            text: err.response.data.status ? err.response.data.status : 'Ops, ocorreu um erro ao buscar os usuários!',
            color: 'error'
          })
        })
    },
    retornaUser (item) {
      if (item.distribuidor) return item.distribuidor.dis_nome
      if (item.revendedor) return item.revendedor.rev_nome
      if (item.integrador) return item.integrador.int_nome
      return 'Master'
    },
    saveEditUser () {
      if (!this.$refs.formUsuarios.validate()) {
        this.$root.SnackControl.open(this, {
          text: 'Por favor, preencha os campos corretamente.',
          color: 'warning'
        })
        return
      }
      this.salvando = true
      let endpoint = 'usuarios/novo'
      let editado = false
      if (this.usuario.uuid_usu_id) {
        endpoint = 'usuarios/edita'
        editado = true
      }

      if (this.user.uuid_dis_id) {
        this.usuario.uuid_dis_id = this.user.uuid_dis_id
      }

      if (this.user.uuid_int_id) {
        this.usuario.uuid_int_id = this.user.uuid_int_id
      }

      if (this.user.uuid_rev_id) {
        this.usuario.uuid_rev_id = this.user.uuid_rev_id
      }

      const formData = new FormData()
      Object.keys(this.usuario).map((key) => {
        if (key === 'usu_imagem') {
          if (this.$refs.file) {
            formData.append(`usu_imagem`, this.usuario.usu_imagem)
          }
        } else if (key === 'usu_permissao_publicidades') {
          formData.append(`usu_permissao_publicidades`, this.usuario.usu_permissao_publicidades ? 1 : 0)
        } else {
          if (this.usuario[key] != null) {
            formData.append(key, this.usuario[key])
          }
        }
      })
      Api.post(endpoint, formData)
        .then((response) => {
          this.salvando = false
          if (response.data.error) {
            this.$root.SnackControl.open(this, {
              text: response.data.error,
              color: 'error'
            })
            return false
          }
          this.$root.SnackControl.open(this, {
            text: editado ? 'Usuário atualizado com sucesso!' : 'Usuário cadastrado com sucesso!',
            color: 'success'
          })
          this.closeDialog()
          this.getUsers()
        })
        .catch((error) => {
          this.salvando = false
          this.$root.SnackControl.open(this, {
            text: error.response ? error.response.data.msg : 'Ops! Ocorreu um erro!',
            color: 'error'
          })
        })
    },
    removeUser () {
      this.salvando = true
      Api.delete(`usuarios/remove/${this.usuario.uuid_usu_id}`)
        .then(res => {
          this.$root.SnackControl.open(this, {
            text: res.data.msg
          })
          this.dialogExcluir = false
          this.salvando = false
          this.closeDialog()
          this.getUsers()
        })
        .catch(err => {
          console.log(err)
          this.salvando = false
          this.$root.SnackControl.open(this, {
            text: err.response ? err.response.data.message : 'Erro ao remover usuário!',
            color: 'error'
          })
        })
    },
    openNovo (item) {
      this.usuario = JSON.parse(JSON.stringify(item))
      this.dialogNovo = true
    },
    openDialogDelete (item) {
      this.usuario = JSON.parse(JSON.stringify(item))
      this.dialogExcluir = true
    },
    cancelUsuarioDelete () {
      this.closeDialog()
      this.dialogExcluir = false
    },
    closeDialog () {
      this.usuario = {
        uuid_gru_id: '',
        usu_nome: '',
        usu_email: '',
        usu_apelido: '',
        password: ''
      }
      if (this.$refs.formUsuarios) {
        this.$refs.formUsuarios.resetValidation()
      }
      this.dialogNovo = false
    },
    removeImagem () {
      this.usuario.usu_imagem = ''
      this.usuario.remover_imagem = true
      this.dialogDeletarImagem = false
    }
  },
  created () {
    this.loadFunctions()
    this.user = JSON.parse(localStorage.getItem('user'))
  }
}
</script>

<style lang="scss" scoped>
@import "@scss/_variables.scss";
@import "@scss/_ui.scss";
>>> .v-text-field--outlined .v-input__append-outer, .v-text-field--outlined .v-input__prepend-outer {
  margin-top: 8px!important;
}
</style>



// WEBPACK FOOTER //
// src/pages/configuracoes/Usuarios.vue